var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    directives: [{
      name: "resize",
      rawName: "v-resize",
      value: _vm.updateContainerWidth,
      expression: "updateContainerWidth"
    }],
    key: 'm-image-marker-src-' + _vm.src,
    ref: "imageContainer",
    staticClass: "ma-0",
    style: _vm.backgroundColor + "border: 1px solid lightgrey;"
  }, [_c('v-spacer'), _c('m-image-marker-canvas', {
    attrs: {
      "src": _vm.src,
      "markerSize": _vm.markerSize,
      "markers": _vm.markers,
      "deactivated": _vm.deactivated,
      "readonly": _vm.readonly,
      "maxHeight": _vm.maxHeight,
      "containerWidth": _vm.containerWidth
    },
    on: {
      "imageLoaded": _vm.updateContainerWidth,
      "markerCreated": function markerCreated($event) {
        return _vm.$emit('markerCreated', $event);
      },
      "markerClicked": function markerClicked($event) {
        return _vm.$emit('markerClicked', $event);
      },
      "markerHover": function markerHover($event) {
        return _vm.$emit('markerHover', $event);
      },
      "mouseoverMarker": function mouseoverMarker($event) {
        return _vm.$emit('mouseoverMarker', $event);
      },
      "mouseleaveMarker": function mouseleaveMarker($event) {
        return _vm.$emit('mouseleaveMarker', $event);
      }
    }
  }), _c('v-spacer'), _c('debug', {
    staticStyle: {
      "position": "absolute",
      "top": "0px"
    }
  }, [_vm._v(" markers: " + _vm._s(_vm.markers) + " "), _c('br')])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }